import styles from "./ProfitLossTable.module.scss";

export const getProfitLossCellClassName = (
    isTotal: boolean,
    isSummary: boolean,
): string | undefined => {
    if (isTotal) {
        return styles.totalCell;
    }
    if (isSummary) {
        return styles.summaryCell;
    }
    return undefined;
};
